import { HStack, Img } from "@chakra-ui/react";
import React from "react";
import { NavLogo } from "./navigation/NavBar.elements";

const Logo = () => {
  const logo =
    "https://res.cloudinary.com/wow-importer/image/upload/v1664462670/my-portfolio/logo_ggwato.svg";

  return (
    <NavLogo to="/">
      <HStack spacing={{ base: "-2px", sm: "2px" }}>
        <Img h="1.7rem" src={logo} />
      </HStack>
    </NavLogo>
  );
};

export default Logo;
